module.exports = __webpack_public_path__ + "static/media/Ear infection.37c465c3.webp";